const initialValues = {
  directorate_name: '',
};
export default initialValues;
